import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px 1px 1px 1px);\n  clip: rect(1px, 1px, 1px, 1px);\n  white-space: nowrap;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  flex: 1;\n  color: ", ";\n  line-height: 19px;\n  font-size: 14px;\n  font-weight: 400;\n  width: 100%;\n  outline: none;\n  padding: 0px;\n  &::-webkit-search-decoration,\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-results-button {\n    display: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  /* Firefox specific */\n  background-color: transparent;\n  min-width: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 14px;\n  margin: 0 15px 0 10px;\n  visibility: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 36px;\n  margin-left: 10px;\n  flex: 0;\n  min-width: 95px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 9px 0 14px;\n  width: 16px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 10px;\n  height: 44px;\n  width: 195px;\n  min-width: 195px;\n  display: flex;\n  align-items: center;\n  flex: 1;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import CloseSVG from '../../../assets/icons/subtract-black.svg';
import MagnifyingGlassSVG from '../../../assets/icons/magnifying-glass.svg';
import styled from '../../../utils/styling/styled-components';
import { SEARCH_CLEAR, SEARCH_CTA, SEARCH_TERM, SEARCH_TRIGGER } from '../../../utils/testing/TestIDs';
import { Button } from '../../../Button';
var Wrapper = styled.div(_templateObject());
var Container = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.ivoryLight;
}, function (props) {
  return props.theme.breakpoints.md;
});
var SearchTrigger = styled.img(_templateObject3());
var SearchButton = styled(Button)(_templateObject4());
var SearchClear = styled.img(_templateObject5(), function (props) {
  return props.visible ? 'visible' : 'hidden';
});
var SearchInput = styled.input(_templateObject6(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.colors.stone;
});
var Label = styled.label(_templateObject7());
var enhance = compose(withState('searchTerm', 'setSearchTerm', ''), withHandlers(function () {
  var searchInput = null;
  return {
    handleChange: function handleChange(_ref) {
      var setSearchTerm = _ref.setSearchTerm,
          onChange = _ref.onChange,
          disabled = _ref.disabled;
      return function (event) {
        if (!disabled) {
          setSearchTerm(event.target.value);
          onChange(event.target.value);
        }
      };
    },
    handleClear: function handleClear(_ref2) {
      var setSearchTerm = _ref2.setSearchTerm,
          onChange = _ref2.onChange,
          disabled = _ref2.disabled;
      return function () {
        if (!disabled) {
          setSearchTerm('');
          onChange('');
        }
      };
    },
    handleKeyPress: function handleKeyPress(_ref3) {
      var onSearch = _ref3.onSearch,
          searchTerm = _ref3.searchTerm,
          disabled = _ref3.disabled;
      return function (_ref4) {
        var key = _ref4.key;

        if (!disabled && key === 'Enter' && searchTerm) {
          onSearch({
            searchTerm: searchTerm
          });

          if (searchInput) {
            searchInput.blur();
          }
        }
      };
    },
    handleSearch: function handleSearch(_ref5) {
      var onSearch = _ref5.onSearch,
          searchTerm = _ref5.searchTerm,
          disabled = _ref5.disabled;
      return function () {
        if (!disabled && searchTerm) {
          onSearch({
            searchTerm: searchTerm
          });

          if (searchInput) {
            searchInput.blur();
          }
        }
      };
    },
    onRef: function onRef() {
      return function (ref) {
        return searchInput = ref;
      };
    }
  };
}));
var SecondarySearchBox = enhance(function (props) {
  var _props$searchTerm;

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: props.className
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SearchTrigger, {
    onClick: props.handleSearch,
    src: MagnifyingGlassSVG,
    "data-testid": SEARCH_TRIGGER
  }), /*#__PURE__*/React.createElement(Label, null, props.label), /*#__PURE__*/React.createElement(SearchInput, {
    value: props.searchTerm,
    placeholder: props.placeholder || 'Search',
    onChange: props.handleChange,
    onKeyPress: props.handleKeyPress,
    type: "search",
    tabIndex: -1,
    ref: props.onRef,
    "data-testid": SEARCH_TERM,
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(SearchClear, {
    onClick: props.handleClear,
    src: CloseSVG,
    visible: props.searchTerm.length > 0,
    "data-testid": SEARCH_CLEAR
  })), props.searchButton && /*#__PURE__*/React.createElement(SearchButton, {
    onPress: props.handleSearch,
    disabled: ((_props$searchTerm = props.searchTerm) === null || _props$searchTerm === void 0 ? void 0 : _props$searchTerm.length) === 0 || props.disabled,
    "data-testid": SEARCH_CTA
  }, "Search"));
});
export { SecondarySearchBox };